module.exports = __webpack_public_path__ + "img/graph-up.6c6df921.svg";